import React from "react";

export default function TiktokIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 0h1.98c.144.715.54 1.617 1.235 2.512C13.395 3.389 14.297 4 15.5 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"
        fill="#25F4EE"
      />
    </svg>
  );
}
